import { Component, OnInit, ViewChild} from '@angular/core';
import { CommonService } from '../../services/common.service';
import { APIService } from '../../api.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-item-summary',
  templateUrl: './item-summary.component.html',
  styleUrls: ['./item-summary.component.scss']
})
export class ItemSummaryComponent implements OnInit {

  soDataSource = new MatTableDataSource();
  storeDataSource = new MatTableDataSource();
  poDataSource = new MatTableDataSource();
  batchDataSource = new MatTableDataSource();
  jobDataSource = new MatTableDataSource();

  soDisplayedColumns: string[] = ['BuyerCompName', 'OrderNo', 'CstrPONo', 'OrderDate', 'DueDT', 'OrderQty', 'SKU', 'GrandTotal'];                  
  poDisplayedColumns: string[] = ['SellerAgencyName', 'BillTo', 'DocNo', 'ItemQty', 'SKU', 'DocDate', 'DueDT', 'SubTotal', 'GrandTotal'];
  storeDisplayedColumns: string[] = ['strName', 'strQty'];
  batchDisplayedColumns: string[] = ['B', 'Q', 'C', 'E'];
  jobDisplayedColumns: string[] = ['CstrRelName', 'JobNo', 'LaunchDT', 'TargetDT', 'PndgQty', 'SKU', 'Stage'];

  isWeb: boolean = true;
  agencyData: any = [];
  erpAgnData: any = [];
  jarvisData: any = [];
  userRights: any = [];
  allStoreRights: boolean = false;

  storeList: any = [];
  itemSummaryData: any = [];
  storesData: any = [];
  itemCategories: any = [];
  isBatchEnabled: boolean = false;
  selectedStoreQty: any = [];
  total: any = {
    SOItemQty: 0,
    POItemQty: 0,
    SOAmt: 0,
    POAmt: 0
  }
  show: any = {
    scrollBtns: false,
    PODetailLabels: true,
    SODetailLabels: true,
  }
  
  @ViewChild('soSort') set soSort(sort: MatSort) {
    this.soDataSource.sort = sort;
  }
  @ViewChild('poSort') set poSort(sort: MatSort) {
    this.poDataSource.sort = sort;
  }
  @ViewChild('storeSort') set storeSort(sort: MatSort) {
    this.storeDataSource.sort = sort;
  }
  @ViewChild('jobSort') set jobSort(sort: MatSort) {
    this.jobDataSource.sort = sort;
  }
  @ViewChild('batchSort') set batchSort(sort: MatSort) {
    this.batchDataSource.sort = sort;
  }

  constructor(private apiService: APIService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.isWeb = this.apiService.apiCheckWeb();
    let jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let mData = this.apiService.getCookie('M');
    if (mData) {
      this.agencyData = JSON.parse(mData);
    }

    let storeList = this.apiService.getCookie('ERP_Cfg');
    if (storeList) {
      this.storeList = JSON.parse(storeList);
      this.itemCategories = JSON.parse(this.storeList[0].ItemCategories);
      this.storeList = JSON.parse(this.storeList[0].Stores);      
    }

    let erpAgnData = this.apiService.getCookie('ERP_Agn');
    if (erpAgnData) {
      this.erpAgnData = JSON.parse(erpAgnData);      
      this.isBatchEnabled = this.erpAgnData[0].EnblBatches;
    }

    let usersData = this.apiService.getCookie("J");
    if (usersData) {
      this.userRights = JSON.parse(usersData);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.userRights = $.grep(this.userRights, function (o: any) { return o.UserID == ownUserID })[0];
      this.userRights.JobView = (this.erpAgnData[0].EnblProduction && (this.userRights.Prd || this.userRights.PrdCfg || this.userRights.PrdRpts)) ? true : false;
    }

    this.getItemDetails();
  }

  ngAfterViewInit(): void {
    this.soDataSource.sort = this.soSort;
    this.storeDataSource.sort = this.storeSort;
    this.poDataSource.sort = this.poSort;
    this.batchDataSource.sort = this.batchSort;
    this.jobDataSource.sort = this.jobSort;
  } 

  getItemDetails() {
    let itemID = this.commonService.GetParam('IID');
    
    let data = [{
      itemID: itemID,
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'getItemSummary',
      moduleID: 12,
      data: JSON.stringify(data),
    }];

    this.apiService.getData(myParams, this.itemSummarySuccessResp.bind(this), this.itemSummaryFailureResp.bind(this));
  }

  itemSummarySuccessResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var responseData = JSON.parse(res.updatePackage);
        if (responseData.Table[0].ErrCode != -1) {
          this.apiService.successAlert(responseData.Table[0].ErrMsg);
        } else {
          // Items Data
          this.itemSummaryData = responseData.Table1[0]; 
          
          // Batches Data
          this.batchDataSource.data = JSON.parse(this.itemSummaryData.Batches);
          
          // Stores Data
          this.storesData = JSON.parse(this.itemSummaryData.StoreBatches); 

          let myStores: any = [];
          if(this.jarvisData[0].UserID != this.erpAgnData[0].AdminUserID) {
            for(let i: number = 0; i < this.storeList.length; i++){
              if(this.storeList[i].UIDs){
                let selectedUsers = String(this.storeList[i].UIDs).split(",");
                for(let j: number = 0; j < selectedUsers.length; j++){
                  if(selectedUsers[j] == this.jarvisData[0].UserID){
                    myStores.push(this.storeList[i]);
                  }
                }                
              }
              else{
                myStores.push(this.storeList[i]);
              }
              let store = this.storeList[i];
              let currStore = $.grep(this.storesData, function (o: any) { return o.SID == store.StrID });
              let storeQty = 0;
              if (currStore.length > 0) {
                storeQty = currStore[0].Q;
              }        
              this.selectedStoreQty.push({
                strName: store.sNm,
                strQty: Number(storeQty).toFixed(this.itemSummaryData.SKUPrecision),
                itemID: this.itemSummaryData.ItemID,
                strID: store.StrID,
                itemUnit: this.itemSummaryData.SKU
              });
            }
            if(myStores.length == this.storeList.length){
              this.allStoreRights = true;
            }
          }            
          this.storeDataSource.data = this.selectedStoreQty;

          // Sale Orders Data
          this.soDataSource.data = responseData.Table2;

          // Purchase Orders Data
          this.poDataSource.data = responseData.Table3;

          // Production Jobs Data
          this.jobDataSource.data = responseData.Table4;
          
          // Category Name
          if (this.itemSummaryData.CategoryID) { 
              let categoryID = this.itemSummaryData.CategoryID;   
              let tmpCategoryData = $.grep(this.itemCategories, function (o: any) { return o.cid == categoryID});
              if (tmpCategoryData.length > 0) {
                this.itemSummaryData.categoryName = tmpCategoryData[0].cnm ? tmpCategoryData[0].cnm : '';  
              }
              // SubCategory Name
              if (this.itemSummaryData.SubCategoryID) {
                let subCategoryID = this.itemSummaryData.SubCategoryID;    
                let tmpSubCategoryData = $.grep(tmpCategoryData[0].sub, function (o: any) { return o.sid == subCategoryID}); 
                if (tmpSubCategoryData.length > 0) {
                  this.itemSummaryData.subCategoryName = tmpSubCategoryData[0].snm ? tmpSubCategoryData[0].snm : '';
                }
              }          
          }

          // Total SO Item Qty
          if (this.soDataSource.data) {
            for (let s = 0; s < this.soDataSource.data.length; s++) { 
              let tmpSOData: any = this.soDataSource.data;
              if(tmpSOData[s].SKU != this.itemSummaryData.SKU) {
                this.show.SODetailLabels = false;
                break;
              }
              if (tmpSOData[s].OrderQty) {
                this.total.SOItemQty += tmpSOData[s].OrderQty;
              }
              if (tmpSOData[s].GrandTotal) {
                this.total.SOAmt += tmpSOData[s].GrandTotal;
              }
            }  
          }

          // Total PO Item Qty
          if (this.poDataSource.data) {
            for (let s = 0; s < this.poDataSource.data.length; s++) { 
              let tmpPOData: any = this.poDataSource.data;
              if(tmpPOData[s].SKU != this.itemSummaryData.SKU) {
                this.show.PODetailLabels = false;
                break;
              }
              if (tmpPOData[s].ItemQty) {
                this.total.POItemQty += tmpPOData[s].ItemQty;
              }
              if (tmpPOData[s].GrandTotal) {
                this.total.POAmt += tmpPOData[s].GrandTotal;
              }
            }  
          }

          // Hide/Show Scroll Buttons
          let totalRows = this.poDataSource.data.length + this.soDataSource.data.length + this.jobDataSource.data.length + this.batchDataSource.data.length + this.storeDataSource.data.length;
          if (totalRows > 15) {
            this.show.scrollBtns = true;
          }

          // sort
          this.soDataSource.sort = this.soSort;
          this.storeDataSource.sort = this.storeSort;
          this.poDataSource.sort = this.poSort;
          this.batchDataSource.sort= this.batchSort;
          this.jobDataSource.sort = this.jobSort;            
        }
      }
    }
  }

  //failureResp - failure handler
  itemSummaryFailureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  scrollToDiv(targetId: string) {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const targetTop = targetElement.offsetTop;

      window.scroll({
        top: targetTop,
        behavior: 'smooth'
      });
    }
  }
}